import { LocalStorageUtils } from '@assetmark/ui-kit/dist/utils/local-storage.utils';
import { RemoteDataUtils } from '@assetmark/ui-kit/dist/utils/remote-data.utils';
import { BehaviorSubject, of } from 'rxjs';
import { ADVISOR_ID_KEY, LEAD_STRATEGY_ID_KEY } from '../constants/storage.constant';
import { getRedirectPage } from '../helpers/pagehelper';
import { LeadService } from '../lib/das-api/api/lead.service';
import { RiskService } from '../lib/das-api/api/risk.service';
import { LeadQuestionAnswers } from '../lib/das-api/model/leadQuestionAnswers';
import { LeadRiskResponse } from '../lib/das-api/model/leadRiskResponse';
import { RiskProfileResponse } from '../lib/das-api/model/riskProfileResponse';
import { RiskQuestion } from '../lib/das-api/model/riskQuestion';
import { TLeadRiskResponse } from '../models/lead-risk-response';
import { TRiskProfileResponse } from '../models/risk-profile.model';
import { TRiskQuestion, TRiskQuestionChoice } from '../models/risk-question.model';
import { LeadApi } from './lead.api';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace RiskApi {
    export const riskQuestions$ = new BehaviorSubject<TRiskQuestion[]>([]);
    export const getRiskQuestions$ = () => riskQuestions$.asObservable();

    export const leadRisk$ = new BehaviorSubject<TLeadRiskResponse>({ riskProfileId: 0, investmentAmount: 0 });
    export const getLeadRiskProfile$ = () => leadRisk$.asObservable();  

    export const getRiskTypeProfile = () => {
		return RiskService.apiDasV1RiskGet()
			.shareReplay(1);
	};

    export const getRiskProfileData = () => {
		return RiskService.apiDasV1RiskRiskprofilesGet()
            .mapRD(data => data.map(parseRiskProfile))
			.shareReplay(1);
	};

    export const getAllQuesData = (leadId: string, qusId: number, agId: string) => {
        LeadApi.showSpinner$.next(true);
		const response$ = LeadService.apiDasV1LeadLeadIdLeadprofilesQuestionsQuestionnaireIdGet(leadId, qusId, agId)
            .mapRD(data => data.map(parseRiskQuestion));
            response$.subscribe(data => {
                if(data.isSuccess()) {
                    LeadApi.showSpinner$.next(false);
                    riskQuestions$.next(data.value);
                }
            });
	};

    export const saveSelectedQuestionAnswer = (leadId: string, body: Array<LeadQuestionAnswers>, agentId: string, currentRoute: string, questionnaireId = 6) => {
        LeadApi.showSpinner$.next(true);
        const response$ = LeadService.apiDasV1LeadLeadIdLeadprofilesQuestionsQuestionnaireIdPut(leadId, questionnaireId, body, agentId)
        .mapRD(data => data.map(parseRiskQuestion))
        .doRD(data => riskQuestions$.next(data))
        .doRD(data => currentRoute === 'planned_withdrawal' && getGeneratedRiskProfile(agentId));
            response$.subscribe(data => {
                if(data.isSuccess()) {
                    LeadApi.showSpinner$.next(false);
                   LeadApi.redirectToPage$.next(getRedirectPage(currentRoute, ""));
                }
            });
    };

    export const getGeneratedRiskProfile = (advisorId: string) => {
        const savedAdvisortId = LocalStorageUtils.getItem<string>(ADVISOR_ID_KEY);
        const leadStrategyId = LocalStorageUtils.getItem<string>(LEAD_STRATEGY_ID_KEY);
        if(savedAdvisortId.getOrElse('').toLowerCase() === advisorId.toLowerCase() && leadStrategyId.getOrElse('') !== '') {
            LeadService.apiDasV1LeadLeadStrategyIdRiskGet(leadStrategyId.getOrElse(''), advisorId)
            .mapRD(parseLeadRiskResponse)
            .doRD(data => leadRisk$.next(data))
            .subscribe();
        } else {
            //return of(RemoteDataUtils.initial);
        }
    };

    export const parseLeadRiskResponse = (leadRiskResponse: LeadRiskResponse): TLeadRiskResponse => {
        return {
            riskProfileId: leadRiskResponse.riskProfileId || 0,
            investmentAmount: leadRiskResponse.investmentAmount || 0
        };
    };

    export const parseRiskQuestion = (question: RiskQuestion): TRiskQuestion => {
        return {
			questionId: question.questionId || 0,
			sequence: question.sequence || 0,
			question: question.question || '',
			choices: question.choices
				? question.choices.map(ch => ({
						choiceId: ch.choiceId || 0,
						sequence: ch.sequence || 0,
						choice: ch.choice || '',
						score: ch.score || 0,
						selected: ch.selected || false,
				  }))
				: ([] as TRiskQuestionChoice[]),
			selectedChoiceId: question.selectedChoiceId || 0,
		};
    };

    export const parseRiskProfile = (raw: RiskProfileResponse): TRiskProfileResponse => {
        return {
            id: raw.id || 0,
            name: raw.name || '', 
            profileType: raw.profileType || '', 
            description: raw.description || '', 
            gainLoss: {
                id: raw.gainLoss?.id || 0,
                gainPercent: raw.gainLoss?.gainPercent || 0,
                lossPercent: raw.gainLoss?.lossPercent || 0,
                twelveMonthGainPercent: raw.gainLoss?.twelveMonthGainPercent || 0,
                twelveMonthLossPercent: raw.gainLoss?.twelveMonthLossPercent || 0,
                longTermAveragePercent: raw.gainLoss?.longTermAveragePercent || 0,
                standardDeviationMin: raw.gainLoss?.standardDeviationMin || 0,
                standardDeviationMax: raw.gainLoss?.standardDeviationMax || 0,
                maximumDrawdown: raw.gainLoss?.maximumDrawdown || 0,
            }
        };
    };

}